import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import ChevronRightIcon from '@/assets/icon/ic_chevron_right.svg';
import ThumbsUpIcon from '@/assets/icon/ic_thumbs_up.svg';
import ThumbsUpFillIcon from '@/assets/icon/ic_thumbs_up_fill.svg';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
import { useCheckAuth } from '@/utils/checkAuth';
import { Image, Platform } from 'react-native';
import Toast from 'react-native-root-toast';
import styled from 'styled-components/native';
import SccTouchableOpacity from './SccTouchableOpacity';
export default function FeedbackButton({ total, isUpvoted, onPressUpvote, onPressInfoUpdateRequest, onPressAnalytics, }) {
    const checkAuth = useCheckAuth();
    return (_jsxs(Container, { children: [_jsxs(LeftSection, { children: [_jsxs(UpvoteButton, { elementName: "place_detail_upvote_button", disabled: !onPressUpvote, onPress: () => {
                            if (!onPressUpvote)
                                return;
                            if (Platform.OS === 'web') {
                                Toast.show('준비 중입니다 💪', {
                                    duration: Toast.durations.SHORT,
                                    position: Toast.positions.BOTTOM,
                                });
                                return;
                            }
                            checkAuth(() => onPressUpvote());
                        }, children: [isUpvoted ? _jsx(ThumbsUpFillIcon, {}) : _jsx(ThumbsUpIcon, {}), _jsx(UpvoteText, { isUpvoted: isUpvoted, children: "\uB3C4\uC6C0\uB3FC\uC694" }), typeof total === 'number' && total > 0 && (_jsxs(CountSection, { children: [_jsx(CountText, { isUpvoted: isUpvoted, children: total }), _jsx(Divider, {})] }))] }), typeof total === 'number' && total > 0 && (_jsxs(AnalyticsButton, { elementName: "navigate_to_upvote_analytics_button", onPress: () => {
                            if (Platform.OS === 'web') {
                                Toast.show('준비 중입니다 💪', {
                                    duration: Toast.durations.SHORT,
                                    position: Toast.positions.BOTTOM,
                                });
                                return;
                            }
                            checkAuth(() => onPressAnalytics === null || onPressAnalytics === void 0 ? void 0 : onPressAnalytics());
                        }, children: [_jsx(ProfileImage, { source: require('@/assets/img/img_profile.png') }), _jsx(ChevronRightIcon, { color: color.gray30 })] }))] }), onPressInfoUpdateRequest && (_jsx(InfoUpdateButton, { elementName: "place_detail_report_button", onPress: () => {
                    if (Platform.OS === 'web') {
                        Toast.show('준비 중입니다 💪', {
                            duration: Toast.durations.SHORT,
                            position: Toast.positions.BOTTOM,
                        });
                        return;
                    }
                    onPressInfoUpdateRequest === null || onPressInfoUpdateRequest === void 0 ? void 0 : onPressInfoUpdateRequest();
                }, children: _jsx(InfoUpdateText, { children: "\uC815\uBCF4\uC218\uC815 \uC694\uCCAD" }) }))] }));
}
const Container = styled.View `
  height: 24px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
const LeftSection = styled.View `
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;
const UpvoteButton = styled(SccTouchableOpacity) `
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;
const UpvoteText = styled.Text `
  font-family: ${font.pretendardMedium};
  font-size: 13px;
  line-height: 18px;
  color: ${props => (props.isUpvoted ? color.gray80 : color.gray50)};
`;
const CountSection = styled.View `
  gap: 10px;
  flex-direction: row;
  align-items: center;
`;
const CountText = styled.Text `
  font-family: ${font.pretendardMedium};
  font-size: 13px;
  line-height: 18px;
  color: ${props => (props.isUpvoted ? color.gray80 : color.gray50)};
`;
const Divider = styled.View `
  width: 1px;
  height: 16px;
  background-color: ${color.gray20};
`;
const AnalyticsButton = styled(SccTouchableOpacity) `
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;
const ProfileImage = styled(Image) `
  width: 24px;
  height: 24px;
`;
const InfoUpdateButton = styled(SccTouchableOpacity) ``;
const InfoUpdateText = styled.Text `
  font-family: ${font.pretendardRegular};
  font-size: 13px;
  line-height: 18px;
  color: ${color.gray60};
  text-decoration-line: underline;
  text-decoration-color: ${color.gray60};
  text-decoration-style: solid;
`;
